import { Box, makeStyles } from "@material-ui/core";

import Button from "../shared/Button";
import ReportResultDialog from "../shared/dialog/report-result";
import { ReportRunActionsProps } from "../../interface/ReportRunActionsProps";

const useStyles = makeStyles({
  // Sized like the dialog actions rather than stretched across the card: a full-width
  // "Send Report" reads as the card's headline instead of its button.
  action: {
    width: 220,
    maxWidth: "100%",
  },
});

/**
 * How a report is run and how the run is reported, in one place. Each panel supplies its
 * own form and its own detail; none of them gets to invent its own button row or wire
 * the result modal up differently.
 */
const ReportRunActions = ({
  title,
  run,
  onRun,
  label,
  runningLabel,
  disabled,
  maxWidth,
  children,
}: ReportRunActionsProps) => {
  const classes = useStyles();

  return (
    <>
      <Box display="flex" gridGap={16} flexWrap="wrap">
        <div className={classes.action}>
          <Button
            label={run.running ? runningLabel : label}
            color="primary"
            variant="contained"
            onClick={onRun}
            type="button"
            disabled={run.running || disabled}
          />
        </div>
        {run.result && !run.running && (
          <div className={classes.action}>
            <Button
              label="View last run"
              color="primary"
              variant="outlined"
              onClick={run.reopen}
              type="button"
            />
          </div>
        )}
      </Box>

      <ReportResultDialog
        open={run.open}
        title={title}
        result={run.result}
        onClose={run.close}
        maxWidth={maxWidth}
      >
        {children}
      </ReportResultDialog>
    </>
  );
};

export default ReportRunActions;
